import { apiFetch } from '@/api/client'
import { createWorkspaceResourceApi } from '@/api/endpoints/workspaceResource'

const parties = createWorkspaceResourceApi('onboarding-parties')
const multipart = { 'Content-Type': 'multipart/form-data' }

export const onboardingPartiesApi = {
  list: parties.list,
  get: parties.get,
  remove: parties.remove,
  create: (workspaceId, payload) =>
    apiFetch(parties.path(workspaceId), { method: 'POST', body: payload, headers: multipart }),
  // Laravel method spoofing, kept as the backend expects it.
  update: (workspaceId, id, payload) =>
    apiFetch(`${parties.path(workspaceId)}/${id}`, {
      method: 'POST',
      body: { ...payload, _method: 'PUT' },
      headers: multipart,
    }),
  updateStatus: (workspaceId, id, payload) =>
    apiFetch(`${parties.path(workspaceId)}/${id}/status`, { method: 'PUT', body: payload }),
  resendInvitation: (workspaceId, id, payload) => parties.action(workspaceId, id, 'resend', payload),
  invites: (workspaceId, params) => apiFetch(`${parties.path(workspaceId)}/invites`, { params }),
  sendInvitation: (workspaceId, payload) =>
    apiFetch(`${parties.path(workspaceId)}/invites`, { method: 'POST', body: payload }),
  sharedLink: (workspaceId, type) =>
    apiFetch(`${parties.path(workspaceId)}/onboarding-link`, { params: { type } }),
  createSharedLink: (workspaceId, payload) =>
    apiFetch(`${parties.path(workspaceId)}/onboarding-link`, { method: 'POST', body: payload }),
  revokeSharedLink: (workspaceId, type) =>
    apiFetch(`${parties.path(workspaceId)}/onboarding-link`, {
      method: 'DELETE',
      params: { type },
      body: { type },
    }),

  // Public onboarding (token link, no workspace)
  form: (token) => apiFetch(`onboarding/${token}`, { ignoreGlobalCatch: true }),
  submitForm: (token, payload) =>
    apiFetch(`onboarding/${token}`, { method: 'POST', body: payload, headers: multipart }),

  /**
   * Extract questionnaire answers from uploaded documents. Public (`token`), edit
   * (`partyId`) or create (neither) route. Fails soft via ignoreGlobalCatch.
   */
  answerFromFile: (workspaceId, payload, { partyId = null, token = null } = {}) => {
    let url
    if (token) url = `onboarding/${token}/answer-from-file`
    else if (partyId) url = `${parties.path(workspaceId)}/${partyId}/answer-from-file`
    else url = `${parties.path(workspaceId)}/answer-from-file`
    return apiFetch(url, { method: 'POST', body: payload, headers: multipart, ignoreGlobalCatch: true })
  },
}
